module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_37.c1632df8.mp3";